export const TELUGU = 'TELUGU'
export const ENGLISH = 'ENGLISH'
export const HINDI = 'HINDI'
export const TELUGU_LABEL = 'తెలుగు'
export const ENGLISH_LABEL = 'English'
export const HINDI_LABEL = 'हिन्दी'

export const LanguagesList = [
  { label: TELUGU_LABEL, value: TELUGU, enum: 'te' },
  { label: ENGLISH_LABEL, value: ENGLISH, enum: 'en' },
  { label: HINDI_LABEL, value: HINDI, enum: 'hi' }
]

export const LanguageEnums: Record<string, string> = {
  english: 'ENGLISH',
  telugu: 'TELUGU',
  hindi: 'HINDI',
  tamil: 'TAMIL',
  kannada: 'KANNADA',
  marathi: 'MARATHI',
  bengali: 'BENGALI',
  malayalam: 'MALAYALAM',
  odia: 'ODIA',
  gujarati: 'GUJARATI'
}

export const LanguageValues: Record<string, string> = {
  english: 'English',
  telugu: 'Telugu',
  hindi: 'Hindi',
  tamil: 'Tamil',
  kannada: 'Kannada',
  marathi: 'Marathi',
  bengali: 'Bengali',
  malayalam: 'Malayalam',
  odia: 'Odia',
  gujarati: 'Gujarati'
}
